import { useState } from "react";
import {
  BaseUrl,
  AUTH_KEY,
  apiUrl_dialerp,
  subID,
  Appname,
  setLogindata,
  setUserdata,
  staticToken,
} from "../../Services/Urls";
import { makeApiRequest, callApi } from "../../Services/ApiService";

import { getRecords, PostRecords } from "../../Services/ApiCall";
import { decryptOtp } from "../../Services/Helper";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { ApiContext } from "../../Context/Context";

interface AuthModalProps {
  isOpen: boolean;
  onClose: () => void;
  onLoginSuccess: () => void;
}

export default function AuthModal({
  isOpen,
  onClose,
  onLoginSuccess,
}: AuthModalProps) {
  const navigate = useNavigate();
  const context = useContext(ApiContext);

  if (!context) {
    throw new Error("useApiContext must be used within a ApiContextProvider");
  }

  const { logindata, setlogindata, userData, setuserData } = context;

  const [activeTab, setActiveTab] = useState<"login" | "signup">("login");
  const [loginData, setLoginData] = useState({ email: "", password: "" });
  const [MobileNumber, setMobileNumber] = useState("");
  const [Otp, setOtp] = useState("");
  const [Name, setName] = useState("");
  const [Email, setEmail] = useState("");
  const [Pincode, setPincode] = useState("");
  const [city, setCity] = useState("");
  const [cityID, setCityID] = useState("");
  const [state, setState] = useState("");
  const [stateID, setStateID] = useState("");
  const [stateCode, setStateCode] = useState("");
  const [country, setCountry] = useState("");

  const [Step, setStep] = useState(1); // mobile, otp, success
  const [signupData, setSignupData] = useState({
    fullName: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  if (!isOpen) return null;

  const handleSignupSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError("");

    if (
      !signupData.fullName ||
      !signupData.email ||
      !signupData.phone ||
      !signupData.password ||
      !signupData.confirmPassword
    ) {
      setError("Please fill in all fields");
      return;
    }

    if (signupData.password !== signupData.confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    if (signupData.password.length < 6) {
      setError("Password must be at least 6 characters");
      return;
    }

    setIsLoading(true);
    // Simulate signup
    setTimeout(() => {
      setIsLoading(false);
      localStorage.setItem("isLoggedIn", "true");
      localStorage.setItem("userEmail", signupData.email);
      localStorage.setItem("userName", signupData.fullName);
      onLoginSuccess();
    }, 1000);
  };

  const checkMobile = () => {
    if (MobileNumber.length === 10) {
      setIsLoading(true);

      let url = `${BaseUrl}/api/DynamicApp/checkMobileUserMongoDynamicV5`;
      let body = {
        baseTokenKey: AUTH_KEY,
        EmailID: "",
        appVersion: "85",
        deviceOS: "android : 15 : VANILLA_ICE_CREAM : sdk=35",
        mobile: MobileNumber,
        corporateCode: subID,
        appVersionName: "85",
        deviceCountry: "India",
        deviceID: "",
        deviceName: "",
        imeiNumber: "not found",
        countryCode: "91",
        collectionNumber: "1",
        countryName: "India",
      };

      makeApiRequest(
        url,
        body,
        AUTH_KEY,
        (response) => {
          //  console.log("check mobile response", response);
          if (response.hasErrors == false) {
            let url2 = `${BaseUrl}/api/DynamicApp/mobileSendOtpMongoV5?AppVersion=1.85&appName=${Appname}&erpIDprm=0&parentIDprm=${subID}&HideColumns=1&cByPlatform=`;
            let body2 = {
              baseTokenKey: AUTH_KEY,
              resend: "0",
              collectionNumber: "2",
              mobile: MobileNumber,
              corporateCode: subID,
            };

            makeApiRequest(
              url2,
              body2,
              AUTH_KEY,
              (response2) => {
                if (response2.hasErrors === false) {
                  let decryptedCode = decryptOtp(response2.response);

                  //  console.log("decrypted otp", decryptedCode);

                  let url3 = `${apiUrl_dialerp}/api/DynamicSMS/SendSMS?AppVersion=1.85&appName=${Appname}&erpIDprm=0&parentIDprm=${subID}&HideColumns=1&cByPlatform=`;
                  let body3 = {
                    Message: `Otp for ${Appname} App is ${decryptedCode}\nDIALERP Team`,
                    SubscriberID: subID,
                    DltEntityID: "1201159187215982418",
                    TemplateDltID: "1007822973245487897",
                    SenderID: "DALERP",
                    CountryCode: "91",
                    userID: "2",
                    Mobile: MobileNumber,
                  };

                  makeApiRequest(
                    url3,
                    body3,
                    "",
                    (response3) => {
                      //if() console.log("SMS API response", response3);

                      if (response3.hasErrors === false) {
                        setIsLoading(false);
                        setStep(2);
                      } else {
                        setIsLoading(false);
                      }
                    },
                    (error3) => {
                      setIsLoading(false);
                    },
                  );
                } else {
                  setIsLoading(false);
                }
              },
              (error2) => {
                setIsLoading(false);
              },
            );
          } else {
            setIsLoading(false);
            if (response?.errors) {
              setError("User not found. Please sign up.");
              //  setError(response?.errors);
              setActiveTab("signup");
            } else {
              setError("User not found. Please sign up.");
              setActiveTab("signup");
            }

            //setStepLogin(3);
          }
        },
        (error) => {
          setIsLoading(false);
        },
      );
    }
  };

  const handleVerify = () => {
    if (Otp.length === 4) {
      setIsLoading(true);
      let url = `${BaseUrl}/api/DynamicApp/mobileLoginVerifyOTPMongoV5`;
      let body = {
        baseTokenKey: AUTH_KEY,
        appVersion: "85",
        deviceOS: "android : 15 : VANILLA_ICE_CREAM : sdk=35",
        mobile: MobileNumber,
        tabErpID: "753",
        corporateCode: subID,
        otp: Otp,
        appVersionName: "85",
        deviceCountry: "India",
        deviceID: "",
        deviceName: "",
        imeiNumber: "not found",
        countryCode: "91",
        collectionNumber: "1",
        countryName: "India",
      };

      makeApiRequest(
        url,
        body,
        AUTH_KEY,
        (response) => {
          if (response.hasErrors === false && response != null) {
            // onSuccess(response?.response);
            // handleClose();
            // setIsLoading(false);
            setLogindata(response?.response);
            setlogindata(response?.response);
            localStorage.setItem(
              "loginData-UniversalDairy",
              JSON.stringify(response?.response),
            );
            getUserDetails(response?.response?.partySr, response?.response);
          } else {
            setIsLoading(false);
          }
        },
        (error) => {
          setIsLoading(false);
        },
      );
    }
  };

  const getUserDetails = (userID: any, data: any) => {
    getRecords(
      526,
      1,
      -1,
      `{LedgerID: { $in: [${userID}] }}`,
      1,
      "",
      (response) => {
        // console.log("user details response", response);
        if (response.hasErrors === false) {
          if (
            response?.response?.records?.length > 0 &&
            response?.response?.records != null
          ) {
            if (
              response?.response?.records?.[0]?.LedgerGroupID == 24 &&
              response?.response?.records?.[0]?.LedgerID != 1002
            ) {
              alert("You are not authorized to login.");

              handleLogout();
            } else {
              setUserdata(response?.response?.records[0] ?? {});
              setuserData(response?.response?.records[0] ?? {});
              localStorage.setItem(
                "UserData-UniversalDairy",
                JSON.stringify(response?.response?.records[0] ?? {}),
              );
              onLoginSuccess();

              setIsLoading(false);
            }
          } else {
            setIsLoading(false);
          }
        } else {
          console.log("Error fetching user details");
          setIsLoading(false);
        }
      },
    );
  };

  const handleLogout = () => {
    setlogindata({});
    setuserData({});

    setLogindata();
    setUserdata();

    localStorage.removeItem("loginData-UniversalDairy");
    localStorage.removeItem("UserData-UniversalDairy");

    navigate("/");
  };

  const signup = (e: React.FormEvent) => {
    setError("");
    setIsLoading(true);
    e.preventDefault();

    let body = [
      {
        LedgerName: Name,
        LedgerGroup: "Subscriber",
        LedgerGroupID: "70",
        UnderLedgerGroup: "Sundry Debtors",
        UnderLedgerGroupID: "22",
        Status: "Active",
        StatusID: "1",
        LogoPic: "",
        Pincode: Pincode,
        City: city,
        CityID: cityID,
        State: state,
        StateID: stateID,
        StateCode: stateCode,
        Country: country,
        CountryID: "1",
        ContactName: Name,
        SignInMobile: MobileNumber,
        SignInEmail: Email,
        SignInPassword: "",
        SignInGroup: "Subscriber",
        SignInGroupID: "15",
        WarehouseArea: "HO Area",
        WarehouseAreaID: "1",
        WarehouseRegion: "HO Region",
        WarehouseRegionID: "1",
        Seller: "Universal Dairy Tech",
        SellerID: "1001",
        Zone: "HO Zone",
        ZoneID: "1",
        DeliveryRoute: "India",
        DeliveryRouteID: 1,

        Contract: "Subscriber",
        ContractID: "1",

        Division: "Sales",
        DivisionID: "1",
      },
    ];

    PostRecords(1452, 2, body, (response: any) => {
      //console.log("signup response", response);

      if (response.hasErrors === false) {
        setActiveTab("login");
        checkMobile();
      } else {
        setError(response?.errors);
        setIsLoading(false);
      }
    });
  };

  const getPinData = (pinCode: any) => {
    const url = `${BaseUrl}/api/dynamic/AutoFillMapperWise?tabErpID=1760&tabName=Delivery%20Addresses`;
    const body = {
      depth: 10,
      accessRight: 0,
      useRegexSearch: false,
      useAtlusSearch: false,
      userID: 1002,
      filters: "{tabErpID:1760}",
      index: 1,
      isDownload: false,
      columnName: "Pincode",
      toEmailID: "it.manager@ananda.in",
      tabErpID: 1760,
      isUpdate: false,
      dataMapper: {
        CollectionName: "FINANCECONNECT_Pincode",
        filter: `{'Pincode':${pinCode}}`,
        project:
          "{'Pincode':'$Pincode','City':'$City','CityID':'$CityID','StateID':'$StateID','State':'$State','StateCode':'$StateCode','Country':'$Country'}",
        suggestedText: "",
      },
    };

    callApi(
      url,
      body,
      staticToken,
      (response: any) => {
        if (
          response?.hasErrors == false &&
          response?.response?.records != null &&
          response?.response?.records.length > 0
        ) {
          const data = response?.response?.records[0];

          setCity(data?.City);
          setCityID(data?.CityID);
          setState(data?.State);
          setStateID(data?.StateID);
          setStateCode(data?.StateCode);
          setCountry(data?.Country);
        } else {
          alert("Please enter a valid pincode.");
          setCity("");
          setCityID("");
          setState("");
          setStateID("");
          setStateCode("");
          setCountry("");
        }
      },
      (error: any) => {},
    );
  };

  const handleSubmit = (Step: number) => {
    if (Step === 1) {
      checkMobile();
    } else if (Step === 2) {
      handleVerify();
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center z-9">
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onClose}
      />

      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md mx-4 overflow-hidden animate-fade-in">
        {/* Header */}
        <div className="relative bg-gradient-to-r from-amber-500 to-orange-500 px-6 py-4 text-white">
          <button
            onClick={onClose}
            className="absolute top-2 right-4 w-8 h-8 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/30 transition-colors cursor-pointer"
          >
            <i className="ri-close-line text-xl"></i>
          </button>

          <div className="text-center">
            <i className="ri-shopping-cart-2-line text-2xl mb-3"></i>
            <h2 className="text-1xl font-bold">Sign in to Continue</h2>
            <p className="text-amber-100 mt-2 text-sm">
              Please login to proceed with checkout
            </p>
          </div>
        </div>

        {/* Tabs */}
        <div className="flex border-b border-gray-200">
          <button
            onClick={() => {
              setActiveTab("login");
              setError("");
            }}
            className={`flex-1 py-4 text-center font-semibold transition-colors cursor-pointer ${
              activeTab === "login"
                ? "text-amber-600 border-b-2 border-amber-600"
                : "text-gray-500 hover:text-gray-700"
            }`}
          >
            Sign In
          </button>
          <button
            onClick={() => {
              setActiveTab("signup");
              setError("");
            }}
            className={`flex-1 py-4 text-center font-semibold transition-colors cursor-pointer ${
              activeTab === "signup"
                ? "text-amber-600 border-b-2 border-amber-600"
                : "text-gray-500 hover:text-gray-700"
            }`}
          >
            Create Account
          </button>
        </div>

        {/* Form Content */}
        <div className="p-6 hh50">
          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-600 text-sm flex items-center gap-2">
              <i className="ri-error-warning-line"></i>
              {error}
            </div>
          )}

          {activeTab === "login" ? (
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit(Step);
              }}
              className="space-y-4"
            >
              {Step === 1 && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Mobile Number
                  </label>
                  <div className="relative">
                    <i className="ri-phone-line absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"></i>
                    <input
                      type="tel"
                      value={MobileNumber}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, ""); // digits only
                        if (value.length <= 10) {
                          setMobileNumber(value);
                        }
                      }}
                      placeholder="Enter your mobile number"
                      className="w-full pl-11 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent text-sm"
                    />
                  </div>
                </div>
              )}

              {Step === 2 && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Enter OTP
                  </label>
                  <div className="relative">
                    <i className="ri-lock-line absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"></i>
                    <input
                      type="tel"
                      value={Otp}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, ""); // digits only
                        if (value.length <= 4) {
                          setOtp(value);
                        }
                      }}
                      placeholder="Enter your OTP"
                      className="w-full pl-11 pr-12 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent text-sm"
                    />
                    <button
                      type="submit"
                      className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 cursor-pointer"
                    >
                      <i
                        className={
                          showPassword ? "ri-eye-off-line" : "ri-eye-line"
                        }
                      ></i>
                    </button>
                  </div>
                </div>
              )}

              {/* <div className="flex items-center justify-between text-sm">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    className="rounded border-gray-300 text-amber-600 focus:ring-amber-500"
                  />
                  <span className="text-gray-600">Remember me</span>
                </label>
                <button
                  type="button"
                  className="text-amber-600 hover:text-amber-700 font-medium cursor-pointer"
                >
                  Forgot Password?
                </button>
              </div> */}

              <button
                type="submit"
                disabled={isLoading}
                className="w-full py-3 bg-gray-900 text-white rounded-lg font-semibold hover:bg-gray-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
              >
                {isLoading ? (
                  <span className="flex items-center justify-center gap-2">
                    <i className="ri-loader-4-line animate-spin"></i>
                    Signing in...
                  </span>
                ) : Step === 1 ? (
                  "Send OTP"
                ) : (
                  "Verify & Sign In"
                )}
              </button>
            </form>
          ) : (
            <form
              onSubmit={(e) => {
                signup(e);
              }}
              className="space-y-4"
            >
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Full Name
                </label>
                <div className="relative">
                  <i className="ri-user-line absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"></i>
                  <input
                    type="text"
                    value={Name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Enter your full name"
                    className="w-full pl-11 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent text-sm"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Email Address
                </label>
                <div className="relative">
                  <i className="ri-mail-line absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"></i>
                  <input
                    type="email"
                    value={Email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email"
                    className="w-full pl-11 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent text-sm"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Phone Number
                </label>
                <div className="relative">
                  <i className="ri-phone-line absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"></i>
                  <input
                    type="tel"
                    value={MobileNumber}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, ""); // digits only
                      if (value.length <= 10) {
                        setMobileNumber(value);
                      }
                    }}
                    placeholder="Enter your phone number"
                    className="w-full pl-11 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent text-sm"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Pincode
                </label>
                <div className="relative">
                  <i className="ri-phone-line absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"></i>
                  <input
                    type="tel"
                    value={Pincode}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, ""); // digits only
                      if (value.length <= 6) {
                        setPincode(value);
                      }

                      if (value.length === 6) {
                        getPinData(value);
                      }
                    }}
                    placeholder="Enter your Pincode"
                    className="w-full pl-11 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent text-sm"
                  />
                </div>
              </div>

              {/* <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Password
                </label>
                <div className="relative">
                  <i className="ri-lock-line absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"></i>
                  <input
                    type={showPassword ? "text" : "password"}
                    value={signupData.password}
                    onChange={(e) =>
                      setSignupData({ ...signupData, password: e.target.value })
                    }
                    placeholder="Create a password"
                    className="w-full pl-11 pr-12 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent text-sm"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 cursor-pointer"
                  >
                    <i
                      className={
                        showPassword ? "ri-eye-off-line" : "ri-eye-line"
                      }
                    ></i>
                  </button>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Confirm Password
                </label>
                <div className="relative">
                  <i className="ri-lock-line absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"></i>
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    value={signupData.confirmPassword}
                    onChange={(e) =>
                      setSignupData({
                        ...signupData,
                        confirmPassword: e.target.value,
                      })
                    }
                    placeholder="Confirm your password"
                    className="w-full pl-11 pr-12 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent text-sm"
                  />
                  <button
                    type="button"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 cursor-pointer"
                  >
                    <i
                      className={
                        showConfirmPassword ? "ri-eye-off-line" : "ri-eye-line"
                      }
                    ></i>
                  </button>
                </div>
              </div> */}

              <button
                type="submit"
                disabled={
                  isLoading || !MobileNumber || !Pincode || !Name || !Email
                }
                className="w-full py-3 bg-gray-900 text-white rounded-lg font-semibold hover:bg-gray-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
              >
                {isLoading ? (
                  <span className="flex items-center justify-center gap-2">
                    <i className="ri-loader-4-line animate-spin"></i>
                    Creating Account...
                  </span>
                ) : (
                  "Create Account"
                )}
              </button>
            </form>
          )}

          {/* Social Login */}
          {/* <div className="mt-6">
            <div className="relative">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-gray-200"></div>
              </div>
              <div className="relative flex justify-center text-sm">
                <span className="px-4 bg-white text-gray-500">
                  Or continue with
                </span>
              </div>
            </div>

            <div className="mt-4 grid grid-cols-2 gap-3">
              <button className="flex items-center justify-center gap-2 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer">
                <i className="ri-google-fill text-xl text-red-500"></i>
                <span className="text-sm font-medium text-gray-700">
                  Google
                </span>
              </button>
              <button className="flex items-center justify-center gap-2 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl text-blue-600"></i>
                <span className="text-sm font-medium text-gray-700">
                  Facebook
                </span>
              </button>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
}
